export const isValidReviewCriteria = reviewCriteria => {
  return reviewCriteria.filter(rc => rc.score === null && !rc.optional && rc.text === null).length === 0;
};
export const validateNote = note => {
  let noteError = "";
  let isNoteValid = note !== "";
  if (note !== "" && (note === null || note === void 0 ? void 0 : note.length) < 14) {
    noteError = "Feedback should be at least 15 characters long";
    isNoteValid = false;
  }
  return {
    noteError,
    isNoteValid
  };
};